<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <div class="titleStyle">
        <el-input placeholder="手机号" v-model="data.Mobile"></el-input>
        <el-input placeholder="订单号" v-model="data.OrderNumber"></el-input>
        <span class="datesSpan">日期：</span>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select v-model="data.ScenicID" filterable placeholder="全部景区" clearable>
          <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
        </el-select>
        <el-select v-model="data.status" filterable placeholder="验票查询" clearable>
          <el-option
            v-for="item in option"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button @click="chaxun">查询</el-button>
        <el-button class="btnL" @click="exportList" >导出报表</el-button>
      </div>
      <div class="information">
        <el-table
          :data="arr"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
          id="vcfResult"
        >
          <!-- <el-table-column label="序号" type="index"></el-table-column> -->
          <el-table-column prop="scenic_name" label="景区名称">
          </el-table-column>
          <el-table-column prop="CreateTime" label="下单时间"></el-table-column>
          <el-table-column prop="OrderNumber" label="订单号"></el-table-column>
          <el-table-column prop="OnlyCode" label="第三方订单号"></el-table-column>
          <el-table-column prop="OrderCode" label="消费码"></el-table-column>
          <el-table-column label="订单内容" width="400">
            <template slot-scope="scope">
                <div class="orderContent">
                  <span>{{scope.row.order_detail[0].OrderAll.productname}}</span>
                  <span v-if="scope.row.order_detail[0].OrderAll.type==1">游玩时间：{{scope.row.order_detail[0].playdate}}</span>
                  <span v-if="scope.row.order_detail[0].OrderAll.type==0">游玩时间：{{scope.row.order_detail[0].OrderAll.consumebegindate}}--{{scope.row.order_detail[0].OrderAll.consumeenddate}}</span>
                  <span>游客名称：{{scope.row.consumer}}  联系电话：{{scope.row.Mobile}}</span>
                </div>
            </template>
          </el-table-column>
          
          <!-- 
          <el-table-column prop="Mobile" label="接收号码"></el-table-column> -->
          <el-table-column prop="ActFee2" label="订单总额"></el-table-column>
          <el-table-column  label="可退数量">
            <template slot-scope="scope">
             <span>{{ scope.row.nums }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="退票数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.types" @input="onInput()"></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="操作" width="240"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="ticket(scope.row)">退票</el-button>
              <el-button type="text" @click="infoFn(scope.row)">查看详情</el-button>
              <el-button type="text" @click="qrcode(scope.row.code_url)">二维码</el-button>
              <el-button type="text" @click="OrderMsg(scope.row.OrderNumber)">重发短信</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div v-for="(item,index) in arr" :key="index" style="margin-top:2rem;">
            <div class="table_border">
              <div>
                <span>景区名称：</span>
                <span>{{ item.scenic_name }}</span>
              </div>
              <div class="borderight"> -->
               
              <!-- <div>
                <span>订单号：</span>
                <span>{{ item.OrderNumber }}</span>
              </div>
              <div>
                <span>接受号码：</span>
                <span>{{ item.Mobile }}</span>
              </div>
              <div>
                <span>消费码：</span>
                <span>{{ item.OrderCode }}</span>
              </div>
              <div>
                <span>成交时间：</span>
                <span>{{ item.CreateTime }}</span>
              </div>
              <div>
                <span>订单总额：</span>
                <span>{{ item.ActFee2 }}</span>
              </div>
              <div @click="ticket(item)">
                <el-button>退票</el-button>
              </div>
              </div>
            </div> -->
            <!-- <el-table
              :data="item.order_detail"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%">
              <el-table-column prop="goods_name" label="产品名称" >
                <template slot-scope="scope">{{ scope.row.OrderAll.productname }}</template>
              </el-table-column>
              <el-table-column prop="ActPrice2" label="代理价" >
              </el-table-column>
              <el-table-column prop="Count" label="购买数量" >
              </el-table-column>
              <el-table-column prop="UseTime" label="验票日期" >
                <template slot-scope="scope">
                  {{ scope.row.UseTime?scope.row.UseTime:'暂无使用' }}
                </template>
              </el-table-column>
              <el-table-column prop="CountUse" label="已使用" >
              </el-table-column>
              <el-table-column  label="未使用" >
                <template slot-scope="scope">
                  {{ Number(scope.row.Count) - Number(scope.row.CountUse) - Number(scope.row.CancleCount) }}
                </template>
              </el-table-column>
              <el-table-column prop="CancleCount" label="退单" >
              </el-table-column>
              <el-table-column  label="操作" >
                  <template slot-scope="scope">
                    <span class="span_txt" @click="qrcode(item.code_url)">查看二维码</span>
                    <span class="span_txt" @click="OrderMsg(item.OrderNumber)">重发短信</span>
                  </template>
              </el-table-column>
              <el-table-column prop="num" label="可退数量">
                <template slot-scope="scope">
                  <div v-if="Number(scope.row.Count) - Number(scope.row.CountUse) - Number(scope.row.CancleCount)!=0">
                     <el-input v-model="scope.row.Stauts"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>   -->
        <!-- </div> -->
      </div>
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="data.total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div>
    </el-card>
    <div class="fixed" v-if="qecodeFlow">
        <div class="fixed_box">
            <div class="fixed_box_tit">
              <span>二维码</span>
              <img src="@/images/distributor/Grou.png" alt="" @click="closeFlag">
            </div>
            <div class="fixed_box_content">
                <img :src="img" alt="">
            </div>
        </div>
     </div>
    <orderMangDialog v-if="infovisible" ref="infoDialog" :order_id="order_id" @CloseGb="MangDialogClose"></orderMangDialog>
  </div>
</template>
<script>
import orderMangDialog from "./dialog/orderMangDialog.vue";
import {getDistributorTwoOrderList,distributorTwoRefund,getDistributorTwoScenicList,sendDistributorTwoOrderMsg,
  distributorTwoPostExport} from '@/request/index.js'
  export default{
    components: {
      orderMangDialog,
      // orderListDialog
    },
    data(){
      return{
        value:'',
        value1:'',
        options:[],
        option:[
          {
            value:'0',
            label:'未验票'
          },
          {
            value:'1',
            label:'验票'
          },
          {
            value:'2',
            label:'退票'
          }
        ],
        arr:[
        ],
        data:{
          token:window.sessionStorage.getItem('Token'),
          Mobile:'',
          OrderNumber:'',
          start_time:'',
          end_time:'',
          ScenicID:'',
          status:'',
          page:1,
          page_size:8,
          total:0
        },
        img:'',
        qecodeFlow:false,
        infovisible:false,
        order_id:''
      }
    },
    created(){
      this.getList()
      this.getScenList()
    },  
    methods:{
      // 关闭详情
    MangDialogClose(){
      this.infovisible = false
    },
       // 点击产品详情
    infoFn(row) {
      this.order_id = row.OrderID
      this.infovisible = true;
      this.$nextTick(() => {
        this.$refs.infoDialog.Info(row);
      });
    },
      onInput(){
      this.$forceUpdate();
    },
      closeFlag(){
        this.qecodeFlow = false
        this.img = ''
      },
      qrcode(url){
        this.qecodeFlow = true
        this.img = url
      },
      OrderMsg(order_number){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          order_number:order_number
        }
        sendDistributorTwoOrderMsg(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('重发短信成功')
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      exportList(){
        distributorTwoPostExport(this.data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            window.location.href = res.data.result
          }
        })
      },  
      chaxun(){
        this.data.total = 0
        this.data.page = 1
        if(this.value1){
          this.data.start_time = this.value1[0]  + ' 00:00:00'
          this.data.end_time = this.value1[1]  + ' 23:59:59'
        }else{
          this.data.start_time = ''
          this.data.end_time = ''
        }
        this.getList()
      },  
      getScenList(){
        let data= {
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:999
        }
        getDistributorTwoScenicList(data).then(res=>{
          if(res.data.status=='ok'){
            this.options = res.data.result
          }
        })
      },  
      currenchange(e){
        this.data.page = e
        this.getList()
      },  
      ticket(item){
        console.log(item)
        let orderdetailid = ''
        item.order_detail.map(itm=>{
            orderdetailid += itm.OrderDetailID + ','
        })
        if (orderdetailid.length > 0) {
          orderdetailid = orderdetailid.substr(0,orderdetailid.length - 1);
        }
        let ordernum = item.types
        if(orderdetailid==''){
          this.$message.error('可退票数量为0')
        }
        let data = {
          token:window.sessionStorage.getItem('Token'),
          orderid:item.OrderID,
          orderdetailid:orderdetailid,
          ordernum:ordernum,
          distributor_id:item.DistributorID,
        }
        distributorTwoRefund(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('退票成功')
            this.getList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      getList(){
        getDistributorTwoOrderList(this.data).then(res=>{
          console.log(res)
          if(res.data.status=='ok'){
            res.data.result.data.map(item=>{
              item.types = 0
              item.nums = item.order_detail[0].Count - item.order_detail[0].CountUse - item.order_detail[0].CancleCount
            })
            this.arr = res.data.result.data
            this.data.total = res.data.result.total
          }
        })
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
    }
  }
</script>
<style lang="less" scoped>
.titleStyle {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  .el-input {
    width: 220px;
    height: 40px;
    margin-right: 20px;
    margin-bottom: 1rem;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
    margin-bottom: 1rem;
  }
  .el-date-editor {
    min-width:30rem;
    width: 30rem;
    margin-right: 20px;
    margin-bottom: 1rem;
  }
  .el-range-separator{
    line-height: 100%;
  }
  .el-button {
    width: 100px;
    margin-bottom: 1rem;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .btnL {
    margin-bottom: 1rem;
    width: 120px;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    color: #ffffff;
  }
}
.datesSpan{
  color: #666;
  text-align: right;
  font-size: 1.4rem;
  line-height: 40px;
}

.table_border{
  width: 100%;
  height: 50px;
  border: 1px solid #E5E5EA;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  justify-content: space-between;
  >div{
    &:nth-child(1){
      span{
      color: #000;
      font-size: 1.4rem;
      &:nth-child(2){
        font-weight: 600;
      }
    }
    }
  }
}
.borderight{
  display: flex;
  align-items: center;
  >div{
    margin-right: 1.9rem;
    span{
      color: #000;
      font-size: 1.4rem;
      &:nth-child(2){
        font-weight: 600;
      }
    }
  }
}
.el-table{
  border-left: 1px solid #E5E5EA;
  border-right: 1px solid #E5E5EA;
  border-bottom: 1px solid #E5E5EA;
}
.pagination{
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.span_txt{
  color: #246DEB;
  font-size:1.4rem ;
  cursor: pointer;
}
.span_txt:nth-child(2){
  margin-left: 2rem;
}

.fixed{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fixed_box{
  background: #fff;
  width: 42.5rem;
  padding: 2.4rem 0;
}
.fixed_box_tit{
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom:1px solid #E5E5EA ;
  padding-bottom: 1.8rem;
  position: relative;
}
.fixed_box_tit span{
  color: #000000;
  font-size:2rem;
  font-weight: 600;
}
.fixed_box_tit img{
  width: 2rem;
  height: 2rem;
  position: absolute;
  right: 2rem;
  cursor: pointer;
}
.fixed_box_content{
  padding: 4rem;
  box-sizing: border-box;
}
.fixed_box_content img{
  width: 34.5rem;
  height: 34.5rem;
}
.orderContent{
  display: flex;
  flex-direction: column;
}
.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  margin-bottom: 2px;
  &:nth-child(1){
    color: #468BC8;
  }
}
</style>